<template>
  <div class="page">
    <my-header :breadcrumb="breadcrumb"></my-header>
    <div class="content">
      <div class="content-wrap">
        <el-button type="primary" @click="clickBackup">数据库备份</el-button><span class="backup-result">{{backupResult}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from "@/components/admin/header";
import Cookies from "js-cookie";
export default {
name: "backup",
  components: {MyHeader},
  data(){
    return {
      breadcrumb:[
        {name:'设置'},
        {name:'数据库备份'}
      ],
      backupResult:''
    }
  },
  methods:{
    clickBackup(){
      this.$http.post('/v1/backup/backup').then(({data})=>{
        if (data.errcode == 0){
          this.backupResult = data.msg;
        }
      })
    }
  }
}
</script>

<style scoped>
  .backup-result{
    margin: 0 0 0 20px;
    color: green;
  }
</style>
